import { useRuntimeConfig } from '#imports'
import qs from 'qs'
import { MessagePlugin } from 'tdesign-vue-next'

// 后续需要如 FormData 再扩展
interface Config {
  url: string
  method?: string
  data?: any
  params?: any
  responseType?: 'json' | 'blob' | 'text' | 'raw'
  headers?: HeadersInit
  mute?: boolean
}

export default async function request(config: Config) {
  const env = useRuntimeConfig()

  let url = env.public.proxyTarget + '/api' + config.url
  if (config.params) {
    url += '?' + qs.stringify(config.params)
  }

  const requestInit: RequestInit = { method: config.method || 'get', headers: config.headers || {} }
  if (config.data) {
    requestInit.body = JSON.stringify(config.data)
    requestInit.headers['Content-Type'] = 'application/json;charset=UTF-8'
  }

  const raw = await fetch(url, requestInit).catch((err) => err)
  if (!raw.status) {
    !config.mute && MessagePlugin.error('未知异常')
    return Promise.reject(raw)
  }
  if (raw.status !== 200) {
    !config.mute && MessagePlugin.error(raw.status + ' ' + raw.statusText)
    return Promise.reject(raw)
  }
  switch (config.responseType) {
    case 'blob':
      return raw.blob()
    case 'text':
      return raw.text()
    case 'raw':
      return raw.json()
    case 'json':
    default:
      const res = await raw.json()
      if (res.code === 200) {
        return res.data
      } else {
        !config.mute && MessagePlugin.error(res.message || res.msg)
        return Promise.reject(res)
      }
  }
}
